import Swiper from "swiper";
import { Controller } from "@hotwired/stimulus";
import { Navigation, Pagination } from "swiper/modules";

export default class extends Controller {
  static values = { initialSlide: { type: Number, default: 0 } };

  connect() {
    new Swiper(this.element, {
      initialSlide: this.initialSlideValue,
      modules: [Navigation],
      spaceBetween: 8,
      slidesPerGroup: 2,
      slidesPerView: "auto",
      centeredSlides: false,
      centeredSlidesBounds: false,
      mousewheel: true,
      forceToAxis: true,
      cssMode: false,
      loop: true,
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
        },
        480: {
          slidesPerView: "auto",
        },
        768: {
          slidesPerView: "auto",
        },
      },
    });
  }
}
